import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-table _mt-3" }
const _hoisted_2 = { class: "gfu-table__head" }
const _hoisted_3 = { class: "gfu-table__row" }
const _hoisted_4 = { class: "gfu-table__cell _tal _flexb30 _flexb20--l" }
const _hoisted_5 = { class: "gfu-table__cell _tal _flexb30" }
const _hoisted_6 = { class: "gfu-table__cell _flexb40 _flexb50--l" }
const _hoisted_7 = {
  class: "gfu-table__body",
  tabindex: "1"
}
const _hoisted_8 = ["data-qa"]
const _hoisted_9 = {
  class: "gfu-table__cell _tal _flexb30 _flexb20--l",
  "data-qa": "order-state-history:Date"
}
const _hoisted_10 = {
  class: "gfu-table__cell _tal _flexb30",
  "data-qa": "order-state-history:Status"
}
const _hoisted_11 = {
  class: "gfu-table__cell _pa-0 _flexb40 _flexb50--l",
  "data-qa": "order-state-history:Notes"
}
const _hoisted_12 = { class: "_ma-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": true,
    "is-visible": $props.isOpen,
    title: _ctx.Resources.format(_ctx.Resources.YourPledge.StageHistoryModalHeader, $props.orderPublicId),
    width: "wide",
    "is-processing": _ctx.isProcessing,
    onActionClose: $options.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Resources.Common.DateTableHeader), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.Common.StagePaymentStatusTableHeader), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Common.NotesTableHeader), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayedHistory, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `order-state-${item.itemId}`,
              class: "gfu-table__row gfu-table__row--striped",
              "data-qa": `order-state-element:${item.itemId}`
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$format(item.date)), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.status), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("pre", _hoisted_12, _toDisplayString(item.stateNotes), 1 /* TEXT */)
              ])
            ], 8 /* PROPS */, _hoisted_8))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "is-processing", "onActionClose"]))
}